import { Message } from "primereact/message";
import { classNames } from "primereact/utils";
import EquipeIcon from "@/assets/icons/revisao-equipe.svg?react";
import { REVISAO } from "../../../nova-obra.constants";
import { textoOuTraco } from "../../etapa-revisao.utils";
import styles from "../../etapa-revisao.module.scss";
import { Secao } from "../secao";
import type { SecaoEquipeProps, SecaoEquipeViewModel } from "./types-secao-equipe";

export function SecaoEquipeView(props: SecaoEquipeProps & SecaoEquipeViewModel) {
  const { linhas, conflitos, pendentes, onEditar } = props;

  return (
    <Secao id="equipe" Icone={EquipeIcon} titulo={REVISAO.secoes.equipe} onEditar={onEditar}>
      {linhas.length === 0 ? (
        <p className={styles.campoValor}>{REVISAO.equipe.vazio}</p>
      ) : (
        <div className={styles.tabelaWrapper}>
          <table
            className={`${styles.tabela} ${styles.tabelaEquipe}`}
            data-testid="revisao-equipe-tabela"
          >
            <colgroup>
              <col className={styles.colNome} />
              <col className={styles.colPapel} />
              <col className={styles.colInicio} />
              <col className={styles.colFim} />
            </colgroup>
            <thead>
              <tr>
                <th>{REVISAO.equipe.colProfissional}</th>
                <th>{REVISAO.equipe.colPapel}</th>
                <th>{REVISAO.equipe.colInicio}</th>
                <th>{REVISAO.equipe.colFim}</th>
              </tr>
            </thead>
            <tbody>
              {linhas.map((linha) => (
                <tr key={linha.id}>
                  <td>{textoOuTraco(linha.profissionalNome)}</td>
                  <td>{textoOuTraco(linha.papelNome)}</td>
                  <td>{linha.inicioFormatado}</td>
                  <td>{linha.fimFormatado}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
      {/* MS003 (RN15): conflito de alocação é pendência na seção Equipe e não bloqueia. */}
      {conflitos.map((item) => (
        <Message
          key={item.usuarioId}
          severity="warn"
          role="status"
          className={classNames("p-message-block", styles.avisoSecao)}
          pt={{ text: { className: styles.avisoSecaoTexto } }}
          data-testid={item.testId}
          text={item.texto}
        />
      ))}
      {/* MS004 (RN16): papel obrigatório ausente é pendência na seção Equipe e não bloqueia. */}
      {pendentes.map((item) => (
        <Message
          key={item.id}
          severity="warn"
          role="status"
          className={classNames("p-message-block", styles.avisoSecao)}
          pt={{ text: { className: styles.avisoSecaoTexto } }}
          data-testid={item.testId}
          text={item.texto}
        />
      ))}
    </Secao>
  );
}
